const switchMessanges = {
	collaboration: {
		check: 'Alterar colaboração para incompleta.',
		notCheck: 'Alterar colaboração para completa.',
	},
	consensus: {
		check: 'Alterar consenso para incompleto.',
		notCheck: 'Alterar consenso para completo.',
	},
};

export default switchMessanges;
